module.exports = "/assets/data/fc0cb85716e8847fb99ce09ee7b6390c-CF40.data.json";